import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import {gpCommon, gpTemporary} from "../GasPass";
import icon_arrow_white_up from "../static/icons/icon_arrow_white_up.svg";
import icon_clear from "../static/icons/icon_clear.svg";
import {Query} from "../libs/Query";

let controllerDataFormFilterAutocompleteTargetId = null;
let controllerDataFormFilterAutocompleteTimeouts = {};

const ControllerDataForm = ({ data, requireUrl, setPopup, inBlock }) => {

    const [autocomplete, setAutocomplete] = useState(null );


    useEffect( () => {

        if( gpCommon.getObject( data['form'], null ) !== null ) {
            let dataUrl = gpCommon.getString( data['url'], null );
            let currentParams = gpCommon.getObject( data['form']['current'], null );
            if( ( dataUrl !== null ) && ( currentParams !== null ) ) {
                // Preset current query params
                gpTemporary[dataUrl] = currentParams;
            }

            let filterGroups = gpCommon.getArray( data['form']['filter'], [] );
            filterGroups.map( ( filterGroup ) => {
                filterGroup.map( ( filterItem ) => {
                    let itemId = gpCommon.getString( filterItem['id'], null );
                    let itemType = gpCommon.getString( filterItem['type'], null );
                    let itemValue = gpCommon.getString( filterItem['value'], '' );
                    if( ( itemId !== null ) && ( itemType !== null ) ) {
                        if( itemType === 'select' ) {
                            let selectElement = gpCommon.getElement( itemId );
                            if( selectElement !== null ) {
                                selectElement.value = itemValue;
                            }

                        }
                        else if( ( itemType === 'text' ) || ( itemType === 'number' ) || ( itemType === 'autocomplete' ) ) {
                            let inputElement = gpCommon.getElement( itemId );
                            if( inputElement !== null ) {
                                inputElement.value = itemValue;
                            }
                        }
                    }
                });
            });
        }
    }, [data] );

    if( gpCommon.getObject( data['form'], null ) !== null ) {

        let headerColumns = {};
        if( gpCommon.getArray( data['form']['header'], null ) !== null ) {
            gpCommon.getArray( data['form']['header'], [] ).map( ( item ) => {
                headerColumns[ item['id'] ] = item;
            });
        }

        return(
            <div className="flex">
                {( ( inBlock && ( gpCommon.getString( data['title'], null ) !== null ) ) || ( gpCommon.getArray( data['button'], null ) !== null ) ) && <div className="controlButtons">
                    {( inBlock && ( gpCommon.getString( data['title'], null ) !== null ) ) && <h2>{gpCommon.getString( data['title'], '' )}</h2>}
                    {gpCommon.getArray( data['button'], [] ).map( ( button ) => {
                        return(
                            <a key={gpCommon.getString( button['id'], '' )}
                               className="button"
                               href={'/' + gpCommon.getString( button['url'], '' )}
                               onClick={( e ) => onClickItem( button, e )}
                            >
                                {gpCommon.getString( button['value'], '' )}
                            </a>
                        );
                    })}
                </div>}

                {gpCommon.getArray( data['form']['filter'], null ) && <div className="filter">
                    {gpCommon.getArray( data['form']['filter'], [] ).map( ( filterGroup, filterGroupIndex ) => {
                        return(
                            <div key={"filterGroup" + filterGroupIndex} className="flexRow">
                                {filterGroup.map( ( filterItem, filterItemIndex ) => {
                                    let itemKey = "filterGroup" + filterGroupIndex + "Item" + gpCommon.getString( filterItem['id'], filterItemIndex );
                                    let itemType = gpCommon.getString( filterItem['type'], '' );

                                    switch( itemType ) {
                                        case 'select':
                                            return (
                                                <div key={itemKey} className="select-wrapper">
                                                    <select id={gpCommon.getString(filterItem['id'], '')}
                                                            defaultValue={gpCommon.getString(filterItem['value'], '')}
                                                            autoComplete="off"
                                                    >
                                                        {gpCommon.getArray(filterItem['options'], []).map((option, optionIndex) => {
                                                            return (
                                                                <option
                                                                    key={itemKey + "Option" + gpCommon.getString(option['id'], optionIndex)}
                                                                    value={gpCommon.getString(option['id'], '')}
                                                                >{gpCommon.getString(option['value'], '')}</option>
                                                            );
                                                        })}
                                                    </select>
                                                    <img src={icon_arrow_white_up}/>
                                                </div>
                                            );
                                            break;

                                        case 'autocomplete':
                                            return (
                                                <div key={itemKey} className="autocomplete-wrapper">
                                                    <div>
                                                        <input key={itemKey + "Autocomplete" + gpCommon.getString( filterItem['key'], '' )}
                                                               id={gpCommon.getString( filterItem['id'], '' )}
                                                               className="hidden"
                                                               type="text"
                                                               defaultValue={gpCommon.getString( filterItem['value'], '' )}
                                                               autoComplete="off"
                                                        />
                                                        <input key={itemKey + "Autocomplete" + gpCommon.getString( filterItem['key'], '' ) + "Value"}
                                                               id={gpCommon.getString( filterItem['id'], '' ) + "_value"}
                                                               type="text"
                                                               placeholder={gpCommon.getString( filterItem['placeholder'], undefined )}
                                                               defaultValue={( gpCommon.getString( filterItem['value'], null ) !== null ) ? gpCommon.getString( filterItem['description'], '' ) : ''}
                                                               onKeyUp={( e ) => onEventFilterAutocomplete( e.target, 'change', gpCommon.getString( filterItem['url'], null ) )}
                                                               onBlur={( e ) => onEventFilterAutocomplete( e.target, 'blur', null )}
                                                               autoComplete="off"
                                                        />
                                                        <img src={icon_clear} onClick={( e ) => onClearFilterAutocomplete( gpCommon.getString( filterItem['id'], '' ) + "_value" )} />
                                                    </div>
                                                    {( gpCommon.getString( filterItem['id'], '' ) + "_value" === controllerDataFormFilterAutocompleteTargetId )
                                                        && ( gpCommon.getArray( autocomplete, null ) !== null )
                                                        && <div>
                                                            {gpCommon.getArray( autocomplete, [] ).map( ( acItem, acItemIndex ) => {
                                                                return(
                                                                    <div key={itemKey + "AutocompleteItem" + gpCommon.getString( acItem['id'], acItemIndex )} onClick={( e ) => onItemSelectFilterAutocomplete( gpCommon.getString( filterItem['id'], '' ) + "_value", gpCommon.getString( acItem['id'], null ), gpCommon.getString( acItem['value'], null ) )}>
                                                                        <div>{gpCommon.getString( acItem['value'], '' )}</div>
                                                                        {gpCommon.getString( acItem['description'], null ) !== null && <div>{gpCommon.getString( acItem['description'], '' )}</div>}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>}
                                                </div>
                                            );
                                            break;

                                        case 'button':
                                            return (
                                                <input key={itemKey}
                                                       className={gpCommon.getString(filterItem['action'], '') === 'submit' ? "blueButton" : undefined}
                                                       type={gpCommon.getString(filterItem['type'], '')}
                                                       value={gpCommon.getString(filterItem['value'], '')}
                                                       onClick={( e ) => onClickFilterButton( gpCommon.getString(filterItem['action'], '') )}
                                                />
                                            );
                                            break;

                                        case 'span':
                                            return (
                                                <div key={itemKey}
                                                     className="span">{gpCommon.getString(filterItem['value'], '')}</div>
                                            );
                                            break;

                                        case 'shift':
                                            return(
                                                <div key={itemKey} className="shift"></div>
                                            );
                                            break;

                                        default:
                                            return (
                                                <input key={itemKey}
                                                       id={gpCommon.getString( filterItem['id'], '' )}
                                                       type={gpCommon.getString( filterItem['type'], '' )}
                                                       placeholder={gpCommon.getString( filterItem['placeholder'], undefined )}
                                                       defaultValue={gpCommon.getString( filterItem['value'], '' )}
                                                       autoComplete="off"
                                                />
                                            );
                                            break;
                                    }

                                    return null;

                                })}
                            </div>
                        );
                    } )}
                </div>}

                <table className="dataForm">
                    {gpCommon.getArray( data['form']['header'], null ) !== null && <thead>
                        <tr>
                            {gpCommon.getArray( data['form']['header'], [] ).map( ( item ) => {
                                return(
                                    <th key={gpCommon.getString( item['id'], '' )} style={gpCommon.getInteger( item['width'], null ) ? { width: item['width'] + 'px' } : undefined}>{gpCommon.getString( item['value'], '' )}</th>
                                );
                            })}
                        </tr>
                    </thead>}

                    {gpCommon.getArray( data['form']['data'], null ) !== null ? ( <tbody>
                        {gpCommon.getArray( data['form']['data'], [] ).map( ( item ) => {
                            return (
                                <tr key={gpCommon.getString( item['id'], '' )}
                                    className={gpCommon.getString( item['class'], null ) ? gpCommon.getString( item['class'], null ) : ( gpCommon.getString( item['url'], null ) || gpCommon.getString( item['urlExternal'], null ) ? 'selectable' : undefined )}
                                    onClick={( e ) => onClickItem( item, null )}
                                >
                                    {gpCommon.getArray( item['values'], [] ).map( ( value, index ) => {
                                        let isExistColumnHeader = false;

                                        if( gpCommon.getObject( headerColumns[gpCommon.getString( value['id'], '' )], null ) !== null ) {
                                            let textAlign = gpCommon.getString( headerColumns[ gpCommon.getString( value['id'], '' ) ]['align'], null );
                                            let itemType = gpCommon.getString( value['type'], null );

                                            switch( itemType ) {
                                                case 'button':
                                                    return(
                                                        <td key={gpCommon.getString( item['id'], '' ) + gpCommon.getString( value['id'], '' )}>
                                                            <input type="button"
                                                                   className={gpCommon.getString( value['color'], null )}
                                                                   style={textAlign !== null ? { textAlign: textAlign } : undefined}
                                                                   value={gpCommon.getString( value['value'], '' )}
                                                                   onClick={gpCommon.getString( value['url'], null ) !== null ? ( e ) => onClickItem( value, e ) : undefined}
                                                                   />
                                                        </td>
                                                    );

                                                default:
                                                    return(
                                                        <td key={gpCommon.getString( item['id'], '' ) + gpCommon.getString( value['id'], '' )} className={gpCommon.getString( value['color'], null )} style={textAlign !== null ? { textAlign: textAlign } : undefined}>
                                                            {gpCommon.getString( value['value'], '' )}
                                                            {gpCommon.getString( value['description'], null ) && <br />}
                                                            {gpCommon.getString( value['description'], null ) && <span>{gpCommon.getString( value['description'], '' )}</span>}
                                                        </td>
                                                    );
                                            }
                                        }
                                        return null;
                                    })}
                                </tr>
                            );
                        })}
                    </tbody> ) : ( <tbody>
                        <tr>
                            <td className="empty" colSpan={gpCommon.getArray( data['form']['header'], [] ).length}>{gpCommon.getString( data['form']['description'], 'Данные не найдены' )}</td>
                        </tr>
                    </tbody> )}
                </table>

                {gpCommon.getObject( data['form']['pages'], null ) && <div className="paginator">
                    {Object.keys( data['form']['pages'] ).map( ( page ) => {
                        if( data['form']['pages'][page] === '...' ) {
                            return (
                                <div key={"paginatorPage" + page} className="separator">...</div>
                            );
                        }
                        else if( data['form']['pages'][page] === '1' ) {
                            return (
                                <div key={"paginatorPage" + page} className="active">{page}</div>
                            );
                        }

                        return (
                            <div key={"paginatorPage" + page} onClick={( e ) => onClickPaginatorItem( page )}>{page}</div>
                        );
                    })}
                </div>}
            </div>
        );
    }

    return null;

    function onClickItem( item, e ) {
        if( e !== null ) {
            e.preventDefault();
        }
        if( gpCommon.getString( item['url'], null ) ) {
            requireUrl( item['url'], gpCommon.getObject( item['params'], {} ), null );
        }
        else if( gpCommon.getString( item['urlExternal'], null ) ) {
            window.open( gpCommon.getString( item['urlExternal'], null ), '_blank' );
        }
        else if( gpCommon.getString( item['action'], null ) !== null ) {
            let buttonAction = gpCommon.getString( item['action'], null );
            if( buttonAction === 'close' ) {
                setPopup( null );
            }
        }
    }

    function onClickPaginatorItem( page ) {
        let dataUrl = gpCommon.getString( data['url'], null );
        if( dataUrl !== null ) {
            // Store selected query param
            gpTemporary[dataUrl]['page'] = page;

            // Update current data
            requireUrl( dataUrl, {}, null );
        }
    }

    function onEventFilterAutocomplete( target, event, url ) {
        let targetId = target.getAttribute( 'id' );
        if( gpCommon.getString( targetId, null ) !== null ) {

            if( typeof controllerDataFormFilterAutocompleteTimeouts[targetId] != "undefined" ) {
                clearTimeout( controllerDataFormFilterAutocompleteTimeouts[targetId] );
                delete controllerDataFormFilterAutocompleteTimeouts[targetId];
            }

            switch( event ) {
                case 'change':
                    if( targetId.length > 6 ) {
                        let sourceTargetId = targetId.substring( 0, targetId.length - 6 );
                        if( gpCommon.getString( sourceTargetId, null ) !== null ) {
                            let sourceTargetElement = gpCommon.getElement( sourceTargetId );
                            if( sourceTargetElement !== null ) {
                                // Clear source target selected
                                sourceTargetElement.value = '';
                            }
                        }
                    }

                    controllerDataFormFilterAutocompleteTimeouts[targetId] = setTimeout( function( targetId, url ) {
                        delete controllerDataFormFilterAutocompleteTimeouts[targetId];

                        let targetElement = gpCommon.getElement( targetId );
                        if( targetElement !== null ) {
                            let targetElementValue = gpCommon.getString( targetElement.value, '' );

                            let currentQueryParams = {
                                id: targetId,
                                query: targetElementValue
                            };

                            let filterGroups = gpCommon.getArray( data['form']['filter'], [] );
                            filterGroups.map( ( filterGroup ) => {
                                filterGroup.map( ( filterItem ) => {
                                    let itemId = gpCommon.getString( filterItem['id'], null );
                                    let itemType = gpCommon.getString( filterItem['type'], null );
                                    if( ( itemId !== null ) && ( itemType !== null ) ) {
                                        if( itemType === 'select' ) {
                                            let selectElement = gpCommon.getElement( itemId );
                                            if( selectElement !== null ) {
                                                let selectedOptions = gpCommon.getArray( selectElement.selectedOptions, null );
                                                if( selectedOptions !== null ) {
                                                    currentQueryParams[itemId] = selectedOptions[0].value;
                                                }
                                            }

                                        }
                                        else if( ( itemType === 'text' ) || ( itemType === 'number' ) || ( itemType === 'autocomplete' ) ) {
                                            let inputElement = gpCommon.getElement( itemId );
                                            if( inputElement !== null ) {
                                                let inputElementValue = gpCommon.getString( inputElement.value, null );
                                                if( inputElementValue !== null ) {
                                                    currentQueryParams[itemId] = inputElementValue;
                                                }
                                            }
                                        }
                                    }
                                });
                            });

                            if( controllerDataFormFilterAutocompleteTargetId !== targetId ) {
                                controllerDataFormFilterAutocompleteTargetId = targetId;
                                setAutocomplete( null );
                            }

                            new Query().get( url, currentQueryParams, ( response ) => {
                                //
                                let responseStatus = gpCommon.getString( response['status'], '' );
                                if( responseStatus === 'ok' ) {
                                    // Successful
                                    if( ( typeof response['id'] != "undefined" ) && ( typeof response['query'] != "undefined" ) && ( typeof response['autocomplete'] != "undefined" ) ) {
                                        let responseTargetId = gpCommon.getString( response['id'], null );
                                        let responseTargetQuery = gpCommon.getString( response['query'], '' );
                                        let responseAutocomplete = gpCommon.getArray( response['autocomplete'], [] );

                                        if( ( responseTargetId !== null ) && ( controllerDataFormFilterAutocompleteTargetId === responseTargetId ) ) {
                                            let responseTargetElement = gpCommon.getElement( responseTargetId );
                                            if( responseTargetElement !== null ) {
                                                let responseTargetElementValue = gpCommon.getString( targetElement.value, '' );

                                                if( responseTargetElementValue === responseTargetQuery ) {
                                                    setAutocomplete( responseAutocomplete );
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }

                    }, 1000, targetId, url );
                    break;

                case 'blur':
                    controllerDataFormFilterAutocompleteTimeouts[targetId] = setTimeout( function( targetId ) {
                        delete controllerDataFormFilterAutocompleteTimeouts[targetId];

                        if( targetId.length > 6 ) {
                            let sourceTargetId = targetId.substring( 0, targetId.length - 6 );
                            if( gpCommon.getString( sourceTargetId, null ) !== null ) {
                                let sourceTargetElement = gpCommon.getElement( sourceTargetId );
                                if( sourceTargetElement !== null ) {
                                    if( gpCommon.getString( sourceTargetElement.value, null ) === null ) {
                                        // Source target not selected

                                        let bluredTargetElement = gpCommon.getElement( targetId );
                                        if( bluredTargetElement !== null ) {
                                            bluredTargetElement.value = '';
                                        }

                                    }
                                }
                            }
                        }

                        if( controllerDataFormFilterAutocompleteTargetId === targetId ) {
                            controllerDataFormFilterAutocompleteTargetId = null;
                            setAutocomplete(null );
                        }

                    }, 200, targetId );
                    break;
            }
        }
    }

    function onItemSelectFilterAutocomplete( targetId, itemId, itemValue ) {
        if( ( targetId.length > 6 ) && ( itemId !== null ) && ( itemValue !== null ) ) {
            let sourceTargetId = targetId.substring( 0, targetId.length - 6 );
            if( gpCommon.getString( sourceTargetId, null ) !== null ) {
                let targetElement = gpCommon.getElement( targetId );
                let sourceTargetElement = gpCommon.getElement( sourceTargetId );
                if( ( targetElement !== null ) && ( sourceTargetElement !== null ) ) {
                    // Set selected item
                    targetElement.value = itemValue;
                    sourceTargetElement.value = itemId;
                }
            }
        }
    }

    function onClearFilterAutocomplete( targetId ) {
        if( targetId.length > 6 ) {
            let sourceTargetId = targetId.substring( 0, targetId.length - 6 );
            if( gpCommon.getString( sourceTargetId, null ) !== null ) {
                let targetElement = gpCommon.getElement( targetId );
                let sourceTargetElement = gpCommon.getElement( sourceTargetId );
                if( ( targetElement !== null ) && ( sourceTargetElement !== null ) ) {
                    // Set selected item
                    targetElement.value = '';
                    sourceTargetElement.value = '';
                }
            }
        }
    }

    function onClickFilterButton( action ) {
        switch( action ) {
            case 'submit':
                let submitDataUrl = gpCommon.getString( data['url'], null );
                if( submitDataUrl !== null ) {
                    let currentQueryParams = {};

                    let filterGroups = gpCommon.getArray( data['form']['filter'], [] );
                    filterGroups.map( ( filterGroup ) => {
                        filterGroup.map( ( filterItem ) => {
                            let itemId = gpCommon.getString( filterItem['id'], null );
                            let itemType = gpCommon.getString( filterItem['type'], null );
                            if( ( itemId !== null ) && ( itemType !== null ) ) {
                                if( itemType === 'select' ) {
                                    let selectElement = gpCommon.getElement( itemId );
                                    if( selectElement !== null ) {
                                        let selectedOptions = gpCommon.getArray( selectElement.selectedOptions, null );
                                        if( selectedOptions !== null ) {
                                            currentQueryParams[itemId] = selectedOptions[0].value;
                                        }
                                    }

                                }
                                else if( ( itemType === 'text' ) || ( itemType === 'number' ) || ( itemType === 'autocomplete' ) ) {
                                    let inputElement = gpCommon.getElement( itemId );
                                    if( inputElement !== null ) {
                                        let inputElementValue = gpCommon.getString( inputElement.value, null );
                                        if( inputElementValue !== null ) {
                                            currentQueryParams[itemId] = inputElementValue;
                                        }
                                    }
                                }
                            }
                        });
                    });

                    if( gpCommon.getObject( currentQueryParams, null ) !== null ) {
                        gpTemporary[submitDataUrl] = currentQueryParams;
                    }
                    else {
                        try {
                            delete gpTemporary[submitDataUrl];
                        }
                        catch( e ) {
                            //
                        }
                    }

                    requireUrl( submitDataUrl, {}, null );
                }
                break;

            case 'clear':
                let clearDataUrl = gpCommon.getString( data['url'], null );
                if( clearDataUrl !== null ) {
                    // Clear query params
                    try {
                        delete gpTemporary[clearDataUrl];
                    }
                    catch( e ) {
                        //
                    }
                    requireUrl( clearDataUrl, {}, null );
                }
                break;

            case 'setDateToday':
            case 'setDateYesterday':
            case 'setDateBeforeYesterday':
                let dateTodayDataUrl = gpCommon.getString( data['url'], null );
                if( dateTodayDataUrl !== null ) {
                    try {
                        let date = new Date();
                        if( action === 'setDateYesterday' ) {
                            date.setDate( date.getDate() - 1 );
                        }
                        else if( action === 'setDateBeforeYesterday' ) {
                            date.setDate( date.getDate() - 2 );
                        }
                        let dateFormatted = date.getDate().toString().padStart( 2, '0' ) + '.' + ( date.getMonth() + 1 ).toString().padStart( 2, '0' ) + '.' + date.getFullYear().toString();

                        let dateTodaySearchFromElement = gpCommon.getElement( 'search_from' );
                        if( dateTodaySearchFromElement !== null ) {
                            dateTodaySearchFromElement.value = dateFormatted;
                        }

                        let dateTodaySearchTillElement = gpCommon.getElement( 'search_till' );
                        if( dateTodaySearchTillElement !== null ) {
                            dateTodaySearchTillElement.value = dateFormatted;
                        }

                        gpTemporary[dateTodayDataUrl]['search_from'] = dateFormatted;
                        gpTemporary[dateTodayDataUrl]['search_till'] = dateFormatted;
                        delete gpTemporary[dateTodayDataUrl]['page'];

                        requireUrl( dateTodayDataUrl, {}, null );
                    }
                    catch( e ) {
                        //
                    }
                }
                break;
        }
    }


}
ControllerDataForm.propTypes = {
    data: PropTypes.object.isRequired,
    requireUrl: PropTypes.func.isRequired,
    setPopup: PropTypes.func.isRequired,
    inBlock: PropTypes.bool.isRequired
};
export default ControllerDataForm;
